import { ref, watch, computed } from 'vue'
import { defineStore } from 'pinia'
import { usePreferredColorScheme } from '@vueuse/core'
import { ThemeOption } from '~/domain/dashboard/settings/erp/shared/models/ERPSettings'

const LOCAL_KEY = 'settings.themePreference'

const useThemePreferenceStore = defineStore('settings/theme-preference', () => {
  const theme = ref<ThemeOption>(ThemeOption.Auto)
  const preferredColorScheme = usePreferredColorScheme()

  // Inicializar do localStorage
  if (typeof window !== 'undefined') {
    const raw = localStorage.getItem(LOCAL_KEY)
    if (raw === ThemeOption.Auto || raw === ThemeOption.Light || raw === ThemeOption.Dark) {
      theme.value = raw
    }
  }

  // Computed que resolve o tema atual considerando a preferência do sistema
  const resolvedTheme = computed<'light' | 'dark'>(() => {
    if (theme.value === ThemeOption.Auto) {
      return preferredColorScheme.value === 'dark' ? 'dark' : 'light'
    }
    return theme.value as 'light' | 'dark'
  })

  // Estado reativo para saber se está no modo escuro
  const isDark = computed(() => resolvedTheme.value === 'dark')
  const isLight = computed(() => resolvedTheme.value === 'light')

  // Salvar no localStorage
  watch(theme, (v) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(LOCAL_KEY, v)
    }
  }, { immediate: true })

  function setTheme (v: ThemeOption): void {
    theme.value = v
  }

  return {
    theme,
    resolvedTheme,
    isDark,
    isLight,
    setTheme
  }
})

export default useThemePreferenceStore
